import { ROUTES } from '@shared/config/routes'
import costIcon from '../../assets/images/assistant/cost.svg'
import pairingIcon from '../../assets/images/assistant/pairing.svg'
import shapeIcon from '../../assets/images/assistant/shape.svg'

export interface AssistantService {
  id: string
  /** Заголовок карточки; в макете набран капслоком. */
  title: string
  description: string
  /** Иконка из макета; рисуется маской, поэтому цвет берётся от карточки. */
  icon: string
  /** Ширина при высоте `ICON_HEIGHT`: у иконок из макета разные пропорции. */
  iconWidth: number
  path: string
  /** Фон карточки: у каждого сервиса свой, чтобы отличать их с одного взгляда. */
  color: string
}

/**
 * Высота иконки внутри карточки, одинаковая у всех сервисов. В макете иконка
 * 158px на карточке 380px; на экране карточка вдвое меньше, поэтому и иконка
 * пересчитана в той же пропорции.
 */
export const ICON_HEIGHT = 70

/**
 * Сервисы хаба «Помощник». Раздел рассчитан на рост: новый инструмент — это
 * одна запись здесь, вёрстку править не нужно.
 *
 * Калькулятор пересчёта ингредиентов сюда не вынесен намеренно: он берёт
 * состав из открытой карточки и без неё показывает пустой экран, поэтому
 * живёт кнопкой внутри рецепта. «Перерасчёт формы» — его самостоятельный
 * вариант: размеры вводятся руками, карточка не нужна.
 *
 * Цвета — те, что макет показывает глазу: там фон задан с прозрачностью 0.7
 * поверх тёмного холста, а на белой странице те же значения дали бы выцветшие
 * карточки с нечитаемым белым текстом.
 */
export const ASSISTANT_SERVICES: readonly AssistantService[] = [
  {
    id: 'flavors',
    title: 'Фудпейринг',
    // Перенос строки расставлен руками: в карточке главной текст должен
    // ложиться в две ровные строки, а сам по себе он рвётся по ширине.
    // Там, где white-space обычный (хаб «Помощник»), перенос читается как
    // пробел и ничего не меняет.
    //
    // Предлоги и союзы приклеены к следующему слову неразрывным пробелом
    // (\u00a0), иначе они повисают в конце строки. Пишем escape-ом: обычный
    // неразрывный пробел в исходнике не отличить от пробела глазом.
    description: 'Находите удачные\nсочетания вкусов',
    icon: pairingIcon,
    iconWidth: 72,
    path: ROUTES.FLAVORS,
    color: '#5e8aa0',
  },
  {
    id: 'cost-calculator',
    title: 'Калькулятор себестоимости',
    description: 'Считайте себестоимость\nсвоих десертов',
    icon: costIcon,
    iconWidth: 54.5,
    path: ROUTES.COST_CALCULATOR,
    color: '#a19cb3',
  },
  {
    id: 'shape-calculator',
    title: 'Перерасчёт формы и\u00a0размера',
    description:
      'Адаптируйте рецепт под\u00a0другую форму,\nразмер и\u00a0высоту',
    icon: shapeIcon,
    iconWidth: 69,
    path: ROUTES.SHAPE_CALCULATOR,
    color: '#554777',
  },
]
